import { subDays } from "date-fns";
import {
  EnumOwnerType,
  SortFindManyChangelogInput,
  useChangeLogManyQuery,
} from "gql/generated";
import { useMemo } from "react";
import { useParams } from "react-router-dom";
import { useLoggedInAs } from "shared/hooks";

export const useActivity = () => {
  // Get the operatorId from the URL path params
  const { operatorEntityId } = useParams();
  const loggedInAs = useLoggedInAs();

  /**
   * We need to memoize this variable to avoid an infinite loading loop
   * (because the milliseconds change with each render)
   */
  const thirtyDaysAgo = useMemo(() => subDays(new Date(), 30), []);
  const { data, error, loading } = useChangeLogManyQuery({
    variables: {
      filter: {
        entity: {
          _entityId: operatorEntityId,
        },
        createdDateISO: {
          _gt: thirtyDaysAgo,
        },
        // Add special filtering for Organizations
        // Operators can see ALL activity
        // Organization can see ALL operator changes
        // + ALL of their own changes
        // + ALL non-status changes from other organizations
        ...(loggedInAs?.type === EnumOwnerType.Organization
          ? {
              OR: [
                {
                  OR: [
                    {
                      AND: [
                        {
                          owner: {
                            type: EnumOwnerType.Organization,
                          },
                          message: {
                            _notStartsWith: "Status",
                          },
                        },
                      ],
                    },
                    {
                      owner: {
                        entityId: loggedInAs.entityId,
                      },
                    },
                  ],
                },
                {
                  owner: {
                    type: EnumOwnerType.Operator,
                  },
                },
              ],
            }
          : null),
      },
      sort: SortFindManyChangelogInput.CreatedDesc,
      limit: 50,
    },
  });

  return {
    changelog: data?.changeLogMany,
    error,
    loading,
  };
};
